import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UserAppFeatureMatrix} from '@models/api/user/user-app-feature.matrix';
import {environment} from 'environments/environment';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ApiUserService {

    constructor(
        private httpClient: HttpClient,
    ) {
    }

    public getAppFeatureMatrix(): Observable<UserAppFeatureMatrix> {
        return this.httpClient
            .get<UserAppFeatureMatrix>(`${environment.ApolloApiUrl}/User/appFeatureMatrix`);
    }

}
